import { render, staticRenderFns } from "./dashboardLink.vue?vue&type=template&id=6ba0d968&lang=pug&"
import script from "./dashboardLink.vue?vue&type=script&setup=true&lang=js&"
export * from "./dashboardLink.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./dashboardLink.vue?vue&type=style&index=0&id=6ba0d968&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports